import FitAssistantStep from '../Enums/FitAssistantStep.ts';
import { CarInformation } from '../Types/FitAssistantData.ts';
import { getBrand } from '../../../../../../../../../Foundation/Common/code/Helpers/TrackingHelper.js';

export const onFitAssistantOpen = (carInformation: CarInformation[]) => {
  if (typeof google !== 'undefined')
    window.google.tagmanager.add({
      event: 'FA_Open',
      ...getGTMCarInformation(carInformation),
    });
};

export const onFitAssistantSaveData = (carInformation: CarInformation[]) => {
  if (typeof google !== 'undefined')
    window.google.tagmanager.add({
      event: 'FA_Save',
      ...getGTMCarInformation(carInformation),
    });
};

const getGTMCarInformation = (carInformation: CarInformation[]) => {
  const brand = carInformation.find((x: CarInformation) => x.parameterName === FitAssistantStep.Make)?.text;
  const year = carInformation.find((x: CarInformation) => x.parameterName === FitAssistantStep.Year)?.text;
  const model = carInformation.find((x: CarInformation) => x.parameterName === FitAssistantStep.Model)?.text;
  const variation = carInformation.find((x: CarInformation) => x.parameterName === FitAssistantStep.Variation)?.text;

  return {
    brand: brand,
    year: year,
    model: model,
    variation: variation,
    selectedFilter: `${brand} ${model} ${year} | ${variation}`,
    url: window.location.href?.split('?')[0],
  };
};

export const GAtrackAddToCart = () => {
  if (typeof google === 'undefined') return;

  const productDetail = window._THULEDATA?.ProductDetail;
  const adobeProduct = window.adobeDataLayer?.products?.[0];
  const analyticsDataset = document.querySelector('.product-detail__buy-area .analyticsData')?.dataset;

  const products = [
    {
      id: productDetail?.ProductId || analyticsDataset?.productid || '',
      name: productDetail?.WebTitle1 || analyticsDataset?.thuleproductname || '',
      price: document.querySelector('.ga-price')?.textContent?.trim() ?? '',
      metric2: document.querySelector('.ga-discount-price')?.textContent?.trim() ?? '',
      brand: getBrand(),
      category: adobeProduct?.subcategory || analyticsDataset?.subcategory || '',
      variant: '',
      quantity: 1,
    },
  ];

  const analytics = {
    event: 'add_to_cart_NoFA',
    ecommerce: {
      currencyCode: document.querySelector('.currencycode')?.textContent?.trim() ?? '',
      add: {
        products,
      },
    },
  };

  google.tagmanager.add(analytics);
};
